import { render } from "./StockNotification.vue?vue&type=template&id=4b2bdc34&scoped=true"
import script from "./StockNotification.vue?vue&type=script&lang=js"
export * from "./StockNotification.vue?vue&type=script&lang=js"

import "./StockNotification.vue?vue&type=style&index=0&id=4b2bdc34&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2bdc34"]])

export default __exports__